import React, { useState } from "react";
import { Button, Typography, Popover } from 'antd';
import moment from 'moment';
import { FaInfoCircle } from "react-icons/fa";

const { Text } = Typography;

const PaymentFareCardTripjack = ({
    loading,
    openRoomDetailsUpdate,
    hotelDetails,
    handleNavigate
}) => {


    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const totalAdults = hotelDetails?.searchQuery?.roomInfo?.reduce((acc, room) => acc + room?.numberOfAdults, 0);
    const totalChildren = hotelDetails?.searchQuery?.roomInfo?.reduce((acc, room) => acc + room?.numberOfChild, 0);

    return (
        <>

            <div className='footer-price d-md-none'>
                <div className='footer-price-content'>
                    {loading ? (
                        <div className="d-flex align-items-center gap-2">
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <>
                            <div>
                                <h2 className="fw-bold d-flex align-items-center gap-2 mb-0">
                                    ₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.PublishedPriceRoundedOff + openRoomDetailsUpdate?.ris?.[0]?.ServiceTax)}
                                    <Popover
                                        content={
                                            <div>
                                                {openRoomDetailsUpdate?.ris?.[0]?.TotalPublishFare !== 0 ?
                                                    <>
                                                        <div>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <Text>Base Fare: </Text>
                                                                <Text><b>₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.TotalPublishFare)}/-</b></Text>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <Text>Total Discount: </Text>
                                                                <Text><b className='text-danger'>₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.discountAmount)}/-</b></Text>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <Text>Price after Discount: </Text>
                                                                <Text className='ms-1'><b>₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.PublishedPriceRoundedOff)}/-</b></Text>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <Text>Taxes & Fees: </Text>
                                                                <Text><b>₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.ServiceTax)}/-</b></Text>
                                                            </div>
                                                        </div>
                                                    </>

                                                    :
                                                    <>
                                                        
                                                    </>
                                                }
                                                <div className="text-center mt-2 bg-light-success p-1 rounded">
                                                    <h3 className='d-flex justify-content-between'>Total Price:
                                                        <span className='ms-1 fw-bold'>
                                                            ₹{Math.round(openRoomDetailsUpdate?.ris?.[0]?.PublishedPriceRoundedOff + openRoomDetailsUpdate?.ris?.[0]?.ServiceTax)}
                                                        </span>
                                                    </h3>
                                                </div>
                                            </div>
                                        }
                                        title="Payment Detail"
                                        trigger="click"
                                        open={open}
                                        onOpenChange={handleOpenChange}
                                        className="booking-filter"
                                    >
                                        <span><FaInfoCircle /></span>
                                    </Popover>
                                </h2>
                                <p>                                                                                                                                                                                     
                                    {(() => {
                                        const adults = totalAdults || 0;
                                        const children = totalChildren || 0;
                                        const totalGuest = adults + children;
                                        return ` ${totalGuest} `;
                                    })()}
                                    Guest
                                </p>

                            </div>

                        </>
                    )}



                    <Button
                        className="btn bg-light-primary d-inline-block float-end rounded my-3 px-4 fw-bold fs-6 py-2"
                        onClick={handleNavigate}
                        aria-label="continue"
                    >
                        Continue
                    </Button>
                </div>
            </div></>

    );
};

export default PaymentFareCardTripjack;